export default {
  welcome: {
    title: "مرحباً بك في Tabbio",
    body: "خذ جولة سريعة في المحادثة والسيرة الذاتية والبحث عن الوظائف والأتمتة والمهارات.",
    primaryCta: "اعرض لي",
    skipCta: "تخطي الجولة",
  },
  chat: {
    title: "اسأل Tabbio",
    body: "ابدأ بمهمة مهنية واحدة في المحادثة. يخطط Tabbio للخطوة التالية ويسألك قبل إرسال أي شيء.",
    primaryCta: "فهمت",
  },
  drawerIcon: {
    title: "افتح القائمة",
    body: "اضغط هنا في أي وقت للوصول إلى سيرك الذاتية والوظائف والمهام والمهارات والإعدادات.",
    primaryCta: "فهمت",
  },
  drawerItems: {
    title: "تنقّل بسرعة",
    chat: "ابدأ محادثة جديدة مع Tabbio في أي وقت.",
    webcv: "أنشئ سيرتك الأساسية وعدّلها وراجعها.",
    shared: "افتح السير المشتركة معك وراجع الوصول المباشر.",
    analytics: "تابع مشاهدات السيرة وطلبات التقديم من مكان واحد.",
    jobs: "ابحث عن وظائف مناسبة وتابع طلبات التقديم.",
    automatch: "تراقب الأتمتة الفرص وتضع أفضل النتائج للمراجعة.",
    skills: "أضف مهارات مختارة تقوّي سيرتك الذاتية ومطابقاتك.",
    notifications: "مطابقات الوظائف وتحديثات الطلبات والتنبيهات تظهر هنا.",
    settings: "التفضيلات واللغة والحساب.",
  },
  settings: {
    replayLabel: "إظهار جولة المنتج",
    replayDescription: "تجوّل في التطبيق من جديد",
  },
};
